import { jsx as o, Fragment as P, jsxs as b } from "react/jsx-runtime";
import * as c from "react";
import { i as j } from "../node_modules/streamdown/dist/chunk-OGVTOU66.js";
import { useCopilotInstruction as D } from "./global-state.js";
import { undent as I } from "../session.js";
const f = c.createContext(null);
function B({
  children: t,
  components: r
}) {
  const { markdownComponents: s, extraComponentDescription: a } = c.useMemo(() => {
    const i = {}, p = {}, m = [], { code: C = F, pre: g = N, ...w } = r;
    for (const [n, e] of Object.entries(w))
      typeof e == "function" ? i[n] = e : e && typeof e.component == "function" && (p[n] = e.component, typeof e.description == "string" && e.description.trim().length > 0 && m.push(`### ${n}
${I(e.description).trim()}`));
    const y = g, x = C;
    return i.pre = function({ children: n, ...e }) {
      return (n?.props?.className ?? "") === "language-render-component" ? /* @__PURE__ */ o(P, { children: n }) : /* @__PURE__ */ o(y, { ...e, children: n });
    }, i.code = ({ className: n, children: e, ...u }) => {
      if (n === "language-render-component")
        try {
          const k = JSON.parse(e.trim()), { componentName: d, props: v } = k, l = p[d];
          return l == null ? /* @__PURE__ */ b("div", { children: [
            "Failed to render ",
            d
          ] }) : /* @__PURE__ */ o(l, { ...v });
        } catch {
          return /* @__PURE__ */ o("div", { children: "Failed to render custom component" });
        }
      return /* @__PURE__ */ o(x, { ...u, className: n, children: e });
    }, { markdownComponents: i, extraComponentDescription: m.join(`

`) };
  }, [r]);
  D({
    instruction: `## Content Guidelines

1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.
${a.length > 0 ? `2. In addition. You are rendering this chat with a few special components.

  To securely render these components you must:

  1. Emit a code fence with the language \`render-component\`
  2. Insert JSON with a key of \`componentName\` and \`props\`. We will feed the props directly into the referenced react component.

  For example, if you have a component called \`ProfileCard\`, you use it like this:

  \`\`\`render-component
  { "componentName": "ProfileCard", "props": {"userId": "12345" } }
  \`\`\`

  When you emit this, this component will render as a React component in the chat.
  This syntax the equivalent of writing <ProfileCard userId="12345" /> in react.

List of available components:

${a}` : ""}`
  });
  const h = c.useMemo(() => ({ components: s }), [s]);
  return /* @__PURE__ */ o(f.Provider, { value: h, children: t });
}
function E({ children: t }) {
  const r = c.useContext(f);
  if (r == null)
    throw new Error("Markdown must be used within CopilotProvider");
  return /* @__PURE__ */ o(j, { components: r.components, children: t });
}
function N(t) {
  return /* @__PURE__ */ o("pre", { ...t });
}
function F(t) {
  return /* @__PURE__ */ o("code", { ...t });
}
export {
  B as CopilotProvider,
  E as Markdown
};
